    <div>
    	<label for="fieldSelect">Choose a field:</label>
    	<nz-select id="fieldSelect" style="width: 100%" [(ngModel)]="selectedField" nzPlaceHolder="Select a field">
    		<nz-option *ngFor="let field of availableFields" [nzValue]="field" [nzLabel]="field.name">
    		</nz-option>
    	</nz-select>

    	<div class="mt-3" style="text-align: right">
    		<button nz-button nzType="default" (click)="cancel()">Cancel</button>
    		<button nz-button nzType="primary" [disabled]="!selectedField" (click)="submit()">Next</button>
    	</div>
    </div>
